<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <div v-if="sportOptions.length > 2" class="sport-filter">
          <button
            v-for="opt in sportOptions"
            :key="opt"
            type="button"
            class="sport-pill"
            :class="{ active: selectedSport === opt }"
            @click="selectSport(opt)"
          >
            {{ sportLabel(opt) }}
          </button>
        </div>
        <pick v-for="p in filteredPicks" v-if="picks" :key="p.id" :pick="p"></pick>
        <p v-if="picks && picks.length === 0">
          There are no premium picks currently posted. To receive picks
          immediately when they are posted, please set up pick notifications in
          the
          <router-link :to="{ path: '/myaccount' }">
            my account section.
          </router-link>
        </p>
      </div>
      <div id="sidebar">
        <adsense
          ad-client="ca-pub-8213113866781504"
          ad-slot="7997332272"
          ad-style="display:inline-block;width:250px;height:250px"
          ad-format="auto"
        >
        </adsense>
      </div>
    </div>
  </div>
</template>

<script>
import Adsense from "../components/adsense.vue";
import Pick from "../components/pick.vue";
import PickRepository from "../data/pick.repository.js";
export default {
  components: {
    adsense: Adsense,
    pick: Pick,
  },
  data() {
    return {
      picks: null,
      selectedSport: "All",
    };
  },
  computed: {
    sportOptions() {
      var seen = {};
      var options = ["All"];
      (this.picks || []).forEach((p) => {
        var name = this.sportName(p);
        if (!seen[name]) {
          seen[name] = true;
          options.push(name);
        }
      });
      return options;
    },
    filteredPicks() {
      if (!this.picks || this.selectedSport === "All") return this.picks || [];
      return this.picks.filter((p) => this.sportName(p) === this.selectedSport);
    },
  },
  created() {
    PickRepository.getPremium().then((p) => {
      this.picks = p;
    });
  },
  methods: {
    sportName(pick) {
      return (pick && pick.sport && pick.sport.sport) || "Other";
    },
    sportLabel(value) {
      if (value === "NCAAF") return "CFB";
      if (value === "NCAAB") return "CBB";
      return value;
    },
    selectSport(value) {
      this.selectedSport = value;
    },
  },
  metaInfo: {
    title: "View Picks",
  },
};
</script>

<style lang="css" scoped>
.sport-filter {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  white-space: nowrap;
  padding: 4px 0 12px;
  margin-bottom: 6px;
}
.sport-pill {
  flex: 0 0 auto;
  border: 1px solid #bbb;
  border-radius: 999px;
  padding: 4px 14px;
  font-size: 13px;
  background: #f4f4f4;
  color: #333;
  cursor: pointer;
}
.sport-pill.active {
  background: #c0392b;
  color: #fff;
  border-color: #c0392b;
}
</style>



// WEBPACK FOOTER //
// ViewPicks.vue?066a7c5e